import { Resource } from "../resource/resource.model";


export class PreferenceWebhook extends Resource {
    name: string;
    type: string;
    webhookId: string;
    webhookUrl: string;
    payloadFormat: string;
    responseMapping: string;
    triggerActions: string[];
    signatureType: string;
    createdAt: Date;
    updatedAt: Date;
    description?: string;
    emailNotify?: { enabled: boolean; recipients?: string[] };
}
